import React from 'react';
import { Col, Management, Row } from 'components';
import { ManagerModel } from 'models/Manager';
import { EditManagementModal } from './edit';
import { SalesManagers } from './salesManagers';
import styles from './styles.module.scss';
import { useManagement } from './useManagement';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';

export interface SalesManagerType {
  brandId?: string;
  brandSalesManagerId?: string;
  salesManager: ManagerModel;
  salesManagerAssistant: ManagerModel;
  countryResponseList?: { id: string; name: string; flagLocation?: string }[];
}

export type ManagementType = {
  purchaseManager: ManagerModel;
  purchaseManagerAssistant: ManagerModel;
  postSalesManager: ManagerModel;
  postSalesManagerAssistant: ManagerModel;
  salesManagers: SalesManagerType[];
};

export const BrandManagement = React.memo(() => {
  const { managementData, salesManagers, openEditManagement, onOpenCloseEditManagement } = useManagement();
  const { hasAccess } = useAccessControl();
  return (
    <Row wrap={false} className={styles.brand_management}>
      <Col flex={'566px'}>
        <HasAccess role={PERMISSIONS.brands.management.read}>
          <Management
            title={'Management'}
            hasAccessToEdit={hasAccess(PERMISSIONS.brands.management.write)}
            onAddModalStateChange={onOpenCloseEditManagement}
            managementData={managementData}
          />
        </HasAccess>
        <HasAccess role={PERMISSIONS.brands.sales_management.read}>
          <SalesManagers salesManagers={salesManagers} />
        </HasAccess>
      </Col>
      <EditManagementModal openUpdateModal={openEditManagement} onCancel={onOpenCloseEditManagement} />
    </Row>
  );
});
